import { render } from "./EditMandature.vue?vue&type=template&id=5999d744&ts=true"
import script from "./EditMandature.vue?vue&type=script&lang=ts"
export * from "./EditMandature.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__